import { Greyx, White } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const SURVEY_APP_BAR_BORDER_BOTTOM_WIDTH = "1px";

export const SurveyAppBar = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 0,
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10,
  backgroundColor: White.main,
  borderBottom: `${SURVEY_APP_BAR_BORDER_BOTTOM_WIDTH} solid ${Greyx[200]}`,
});
